<script lang="ts" setup>
  import { BaseInput } from '@qic/ui-components'
  import { computed } from 'vue'
  import {
    PASPORT_MASK,
    PASPORT_MAX_LENGTH,
    PASPORT_TOKEN,
    PASPORT_PATTERN,
  } from './PasportNumberInput.constants'

  interface Props {
    modelValue: string
    label?: string
    errors?: string[]
  }
  interface Emits {
    (e: 'update:modelValue', value: string): void
  }

  const props = withDefaults(defineProps<Props>(), {
    modelValue: '',
  })

  const emit = defineEmits<Emits>()

  const value = computed({
    get: () => props.modelValue,
    set: (value) => {
      emit('update:modelValue', value)
    },
  })
</script>

<template>
  <BaseInput
    v-model="value"
    v-bind="$attrs"
    :label="label || $t('travellers_passport')"
    :mask="PASPORT_MASK"
    :max-length="PASPORT_MAX_LENGTH"
    :mask-tokens="{ [PASPORT_TOKEN]: { pattern: PASPORT_PATTERN } }"
    :errors="errors"
  />
</template>
